module.exports = __webpack_public_path__ + "img/logo.1d417d3b.svg";